import server_api from "./server_api";

// SMS Provider

export const createSmsServiceProvider = (data) => {
  return server_api.post("/notifications/sms-service-provider", data);
};
export const getSmsServiceProviders = () => {
  return server_api.get("/notifications/sms-service-provider");
};
export const getAllSmsServiceProviders = () => {
  return server_api.get("/notifications/sms-service-provider/get_all");
};
export const getSmsServiceProvider = (id) => {
  return server_api.get(`/notifications/sms-service-provider/${id}`);
};
export const updateSmsServiceProvider = (id, data) => {
  return server_api.patch(
    `/notifications/sms-service-provider/${id}`,
    data
  );
};
export const deleteSmsServiceProvider = (id) => {
  return server_api.delete(`/notifications/sms-service-provider/${id}`);
};
